import { render, staticRenderFns } from "./HrSalaryCalcSpecial.vue?vue&type=template&id=2a9f4d5e&scoped=true&"
import script from "./HrSalaryCalcSpecial.vue?vue&type=script&lang=js&"
export * from "./HrSalaryCalcSpecial.vue?vue&type=script&lang=js&"
import style0 from "./HrSalaryCalcSpecial.vue?vue&type=style&index=0&id=2a9f4d5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9f4d5e",
  null
  
)

export default component.exports